import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastMessage } from './../../../../core/models/chapitreeval';
import { serverError } from './../../../../core/models/messages';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-details-template',
  templateUrl: './details-template.component.html',
  styleUrls: ['./details-template.component.css'],
})
export class DetailsTemplateComponent {
  selectedTypeResponse: string | null = null;
  esn_id!: string | null;
  evaluation_id!: string | null;
  ideval: any;
  chapitreLists: any[] = [];
  chapitreList: { name: string }[] = [];
  Listquestion: any;
  /* any */

  type = [
    { id: '1', name: 'Annuelle' },
    { id: '2', name: 'Suivi' },
  ];

  selectedtemplate: any;
  questionForm: FormGroup = this.createQuestionForm();

  chapitreDetails: any;
  templateForm: FormGroup = this.createevaluationForm();
  /* unsubscription */
  DetailsForm: FormGroup = this.createevaluationForm();
  private unsubscribeAll: Subject<void> = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private ajouttemlateservice: EsnAppeloffreService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.esn_id = this.localStorageService.getData('clientConnected');
    this.getId();

    this.getListChapitre();

    this.getChapitreById();
    // this.getListquestion();
  }

  createevaluationForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name],
      type: [data && data.type],
      dedicated_to: [data && data.dedicated_to],
      esn_id: [this.localStorageService.getData('clientConnected')],
      id: [''],
    });
  }

  toastMessages: ToastMessage = {
    success: 'Ajout de votre chapitre avec succès',
    error: 'Chapitre avec ce nom existe déjà',
  };
  createChapitre() {
    if (this.templateForm.invalid) {
      // Handle invalid form (optional)
      return;
    }

    this.spinner.show();
    this.ajouttemlateservice
      .ajoutertemplate(this.templateForm.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res,', res);
          this.evaluation_id = res.data.id;
          console.log('evaluationid', this.evaluation_id);
          this.spinner.hide();
          this.toastr.success(this.toastMessages.success);
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
            this.toastr.error(this.toastMessages.error);
          } else {
            this.toastr.error(serverError);
          }
        },
      });
  }

  getListChapitre() {
    console.log('hello');
    this.ajouttemlateservice
      .getchapitreList(this.esn_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.chapitreList = res.data.items.data;
          console.log('this.chapitreList', this.chapitreList);
        },
        error: () => {
          this.toastr.error(serverError);
        },
      });
  }
  // getListquestion() {
  //   console.log('hello');
  //   this.ajouttemlateservice
  //     .getlistequestion(this.evaluation_id)
  //     .pipe(takeUntil(this.unsubscribeAll))
  //     .subscribe({
  //       next: (res) => {
  //         this.Listquestion = res.data.data;
  //         console.log('this.Listquestion', this.Listquestion);
  //       },
  //       error: () => {
  //         this.toastr.error(serverError);
  //       },
  //     });
  // }

  createQuestionForm(data?: any) {
    return this.formBuilder.group({
      question: [data && data.question],
      typeResponse: [data && data.typeResponse, Validators.required],
      chapter_eval_id: [data && data.chapter_eval_id],
      evaluation_id: [''],
    });
  }

  createQuestion() {
    this.questionForm.get('evaluation_id')?.setValue(this.evaluation_id);
    // .patchValue({
    //   evaluation_id: this.evaluation_id,
    // });
    console.log('this.questionForm', this.questionForm.value);

    this.spinner.show();
    this.ajouttemlateservice
      .ajouterquestion(this.questionForm.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(this.toastMessages.success);
          this.closeModal();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error?.message?.name) {
            this.toastr.error(this.toastMessages.error);
          } else {
            this.toastr.error(serverError);
          }
        },
      });
  }
  //////////////////////////////////////////////////////////////////////////////////
  modalRef?: BsModalRef;
  file: any;
  fileError: string = '';
  fileExtention: string = '';
  closeModal() {
    this.modalRef?.hide();
    // this.createQuestionForm.reset()
    // this.formData = new FormData()
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }

  ///////////////////////////////////////////////////////////////////////////////////
  getChapitreById() {
    // Make sure evaluation_id is set before calling the service
    if (!this.evaluation_id) {
      // Handle the case when evaluation_id is not set
      return;
    }

    this.spinner.show();
    this.ajouttemlateservice
      .detailchapitre(this.evaluation_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.chapitreDetails = res.data;
          console.log('detail', this.chapitreDetails); // Ensure that the structure of your response is correct
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.evaluation_id = params.params['id'];
        this.getChapitreById();
      },
    });
  }
}
